<template>
  <h1 class="text-2xl mb-4 font-bold">
    <slot />
  </h1>
</template>
